

// 21.03 degisti, error messages etc
import React, { useEffect, useState } from "react";
import "../../styles/Common.css";
import axios from "axios";
import config from '../../config/config';
import { useTenant } from "../../context/TenantContext";

const RobotSelection = ({ onChange, robot, folder, disabled }) => {
  const { selectedTenant } = useTenant();
  const [robots, setRobots] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (!folder || !selectedTenant) {
      setRobots([]);
      setError("");
      return;
    }

    const fetchRobots = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("userToken");

        if (!token) {
          setError("User token is missing. Please log in again.");
          setRobots([]);
          return;
        }

        const response = await axios.get(
          `${config.API_BASE_URL}/api/orchestrator/robots/${folder}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
              'selected-tenant': JSON.stringify(selectedTenant),
              'X-UIPATH-OrganizationUnitId': selectedTenant.orch_tenant_id.toString()
            }
          }
        );

        if (!response.data || !Array.isArray(response.data.robots)) {
          setError("Invalid response format from API.");
          setRobots([]);
          return;
        }

        setRobots(response.data.robots);
        setError("");
      } catch (error) {
        console.error("Robot fetch error:", error);
        setError("Failed to fetch robots. Please check your folder that has any robots.");
        setRobots([]);
      } finally {
        setLoading(false);
      }
    };

    fetchRobots();
  }, [folder, selectedTenant]);

  const isDisabled = disabled || !folder || error;

  return (
    <div className="form-group">
      <label>Select Robot *</label>
      <select
        value={robot || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={isDisabled}
      >
        {!folder ? (
          <option value="">Please select folder first</option>
        ) : loading ? (
          <option value="">🔄 Loading...</option>
        ) : error ? (
          <option value="">{error}</option>
        ) : robots.length > 0 ? (
          <>
            <option value="">Select robot</option>
            {robots.map((r) => (
              // <option key={r.Id} value={r.Id}>
              //   {r.Name} - {r.Type}
              // </option>
              <option key={r.Id} value={r.Id} title={`${r.Name} - ${r.Type}`}>
                {r.Name.length > 27 ? r.Name.slice(0, 27) + '...' : r.Name} - {r.Type}
              </option>

            ))}
          </>
        ) : (
          <option value="">No robots available</option>
        )}
      </select>
    </div>
  );
};

export default RobotSelection;
